module.exports = "/static/media/CheerfulTones.e86de023.wav";